<script>
    export default {
        inserted: function (el) {
            let current = 0;
            document.addEventListener("renderProductPagination",()=>{
                let controls = el.querySelectorAll("li[data-type='pr_step']");
                let prev = el.querySelector("li[data-type='pr_prev']");
                let next = el.querySelector("li[data-type='pr_next']");
                var tbodyref = document.getElementById('pc1');
                var productLengthbyId = parseInt(document.getElementById('productsLen').innerHTML);
                let controlLength =  controls.length;

                var totalZwiflocItems = productLengthbyId;

                let pause = false;
                let rows = el.querySelectorAll('.product-row');
                

                let setOnClick = function (element, index) {
                    var clickProductCounter = (current) * 6 ;
                    var toProduct = clickProductCounter + 6;
                    if(toProduct >= totalZwiflocItems){
                        toProduct = totalZwiflocItems;
                    }
                    if((clickProductCounter+1) <= totalZwiflocItems){
                        var clickElement = 'PRODUCTS ( ' + (clickProductCounter + 1) + ' - ' + toProduct + ' OF ' + totalZwiflocItems + ' )';
                        tbodyref.innerHTML = clickElement;
                    }

                    element.onclick = function (e) {
                        pause = true;
                        for (let i = 0; i < controls.length; i++) {
                            controls[i].classList.remove('active');
                            rows[i].style.display = 'none';
                        }

                        for (let i = 0; i < controls.length; i++) {
                            if (i === index) {
                                current = index;
                                controls[i].classList.add('active');
                                rows[i].style.display = 'flex';
                            }
                        }
                    }
                }
                
                for (let i = 0; i < controls.length; i++) {
                    setOnClick(controls[i], i);
                }

                next.onclick = function () {
                    var nextProductCounter = (current+1) * 6 ;
                    
                    var toClickProduct = nextProductCounter + 6;
                    if(toClickProduct >= totalZwiflocItems){
                        toClickProduct = totalZwiflocItems;
                    }

                    if((nextProductCounter+1) <= totalZwiflocItems){
                        var nextElement = 'PRODUCTS ( ' + (nextProductCounter + 1) + ' - ' +  toClickProduct + ' OF ' + totalZwiflocItems + ' )';
                        tbodyref.innerHTML = nextElement;
                    }
                    pause = true;
                    slideTo(current+1);
                }

                prev.onclick = function () {
                    pause = true;
                    if(current == 0){
                        current = 1;
                    }
                    var prevProductCounter = (current-1) * 6 ;

                    var toPrevItems = prevProductCounter - 6;
                    if(toPrevItems >= totalZwiflocItems){
                        toPrevItems = totalZwiflocItems;
                    }

                    var prevElement = 'PRODUCTS ( ' + (prevProductCounter + 1) + ' - ' + toPrevItems + ' OF ' + totalZwiflocItems + ' )';
                    tbodyref.innerHTML = prevElement;
                    slideTo(current-1);
                }

                let slideTo = function (index) {

                    if ((index >= 0) && (index < controlLength)) {
                        for (let i = 0; i < controlLength; i++) {
                            controls[i].classList.remove('active');
                            rows[i].style.display = 'none';
                        }

                        for (let i = 0; i < controlLength; i++) {
                            if (i === index) {
                                current = index;
                                controls[i].classList.add('active');
                                rows[i].style.display = 'flex';
                            }
                        }
                    }

                }

                // setInterval(function () {
                //     if ((current + 1) < controls.length) {
                //         if (!pause) {
                //             slideTo(current + 1);
                //         }
                //     } else {
                //         if (!pause) {
                //             slideTo(0);
                //         }
                //     }
                // }, 100000);
            });
        
        }
        
    }

</script>
